export const getEnvVariable = (key) => {
  if (process.env.NODE_ENV === 'development')
    return process.env[key];
  else return window.env ? window.env[key] : undefined;
};
